import { atom } from "recoil";

export const prizeAddModalStore = atom({
	key: "prizeAddModalStore",
	default: {
		show: false,
		loaded: true,
		name: "",
		description: "",
		currentOption: {
			type: [
				{ value: "money", label: "Money" },
				{ value: "freespins", label: "Freespins" },
				{ value: "tickets", label: "Ticket" },
				{ value: "chest", label: "Chest" },
				{ value: "item", label: "Item" },
			],
			poolType: [
				{ value: "daily", label: "Daily" },
				{ value: "weekly", label: "Weekly" },
				{ value: "monthly", label: "Monthly" },
			],
		},
		icon: null,
		nameTranslationType: null,
		descriptionTranslationType: null,
		order: null,
		fakeWinsPerMonth: "",
		poolType: "",
		poolCount: "",
		conditions: [],
		rewardType: "",
		rewardValue: "",
		providerSelected: null,
		availableGames: [],
		gameSelected: null,
		betAmount: "",
		expiresAt: "",
		chestRewards: [],
		chestType: "",
		chestPrizeId: null,
		chestPrizeSelected: null,
		chestPrizeOptions: [],
		chestPrizeLoading: false,
		chestPrizeMatchMissing: false,
		hidden: false,
		showInBanner: false,
		image: null,
		probability: "",
		link: "",
		active: "",
	},
});
